import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { stripeElementsModes } from "../../../StripeElements/types";

export const useIsSettingUpPaymentMethod = () => {
  const {
    currentCommunityProcessorPaymentMethodConfigurationId,
    isSetupIntentRequired,
    previewMutation,
    stripeElementsMode,
  } = usePaywallCheckoutContext();

  return (
    (currentCommunityProcessorPaymentMethodConfigurationId &&
      stripeElementsMode === stripeElementsModes.setup) ||
    (!currentCommunityProcessorPaymentMethodConfigurationId &&
      (isSetupIntentRequired || previewMutation?.data?.amount_due_now === 0))
  );
};
